import React, { memo, useCallback, useRef, useState } from 'react';
import { Input, InputRef, Popover } from 'antd';
import Picker, { IEmojiData } from 'emoji-picker-react';
import { SmileOutlined } from '@ant-design/icons';

type Props = {
  subject?: string;
  onFocus?: () => void;
  onChange: ({ inputText, emoji, variable }: { inputText?: string; emoji?: string; variable?: string }) => void;
};

const SubjectInput = memo<Props>((props) => {
  const [emojiPicker, shoEmojiPicker] = useState(false);

  const subjectRef = useRef<InputRef | null>(null);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange({ inputText: e.target.value });
    },
    [props]
  );

  const showEmojiPicker = (value: boolean) => {
    shoEmojiPicker(value);
  };

  const onEmojiClick = (event: React.MouseEvent<Element, MouseEvent>, emojiObject: IEmojiData) => {
    props.onChange({ emoji: emojiObject.emoji });
    subjectRef.current?.focus();
  };

  const onFocus = () => {
    props.onFocus?.();
  };

  return (
    <Input
      placeholder="Notification Subject"
      ref={subjectRef}
      value={props.subject}
      onFocus={onFocus}
      onChange={onChange}
      size="large"
      addonAfter={
        <Popover
          content={<Picker disableSkinTonePicker native onEmojiClick={onEmojiClick} disableAutoFocus={true} />}
          onOpenChange={showEmojiPicker}
          open={emojiPicker}
          trigger="click"
        >
          <SmileOutlined />
        </Popover>
      }
    />
  );
});

export default SubjectInput;
